import { useEffect, useState } from 'react';

/** Reageert op CSS media queries; gebruikt voor de mobiel/desktop-layout. */
export function useMediaQuery(query: string): boolean {
  const [komtOvereen, setKomtOvereen] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const lijst = window.matchMedia(query);
    const luister = (event: MediaQueryListEvent) => setKomtOvereen(event.matches);
    setKomtOvereen(lijst.matches);
    lijst.addEventListener('change', luister);
    return () => lijst.removeEventListener('change', luister);
  }, [query]);

  return komtOvereen;
}

/** Breekpunt waarop we van bottom sheet naar zijpaneel schakelen. */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 900px)');
}

/**
 * Vanaf hier is een scherm breed genoeg voor opmaak in kolommen.
 *
 * Een tablet in portret is 744 tot 834 px breed. Dat is te breed voor de
 * telefoonopmaak — kaartjes onder elkaar en een navigatiebalk onderin
 * verspillen daar de halve breedte — maar te smal voor het zijpaneel, dat
 * 480 px opeist en dan te weinig kaart overlaat.
 */
export function useIsTablet(): boolean {
  return useMediaQuery('(min-width: 700px)');
}
